import { useEffect, useState } from "react";

export type Theme = "light" | "dark";

export const useTheme = () => {
    const [theme, setTheme] = useState<Theme>(() => {
        // Проверяем сохраненную тему в localStorage
        const savedTheme = localStorage.getItem("theme") as Theme | null;

        if (savedTheme) {
            return savedTheme;
        }

        // Проверяем системные настройки
        if (
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
            return "dark";
        }

        return "light";
    });

    useEffect(() => {
        const root = document.documentElement;

        if (theme === "dark") {
            root.classList.add("dark");
        } else {
            root.classList.remove("dark");
        }

        // Сохраняем выбор пользователя
        localStorage.setItem("theme", theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
    };

    return { theme, setTheme, toggleTheme };
};
